import React, { Fragment, useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import moment from "moment";
import SelectField from "Components/formControls/HookFields/SelectField";
import { KENDO_DATE_FORMAT } from "src/constants";
import { Typography } from "@material-ui/core";

const FrequencyFilter = ({
  selectedFrequency,
  setSelectedFrequency,
  checkinFrequencyDates,
  label
}) => {
  const [frequencyOptions, setFrequencyOptions] = useState([]);

  const handleFrequencyChange = e => {
    const { value } = get(e, "target");
    setSelectedFrequency(frequencyOptions.find(f => f.name === value));
  };

  useEffect(() => {
    const options = (checkinFrequencyDates || []).map(item => {
      const name = `${moment(item.startDate).format(
        KENDO_DATE_FORMAT
      )} - ${moment(item.endDate).format(KENDO_DATE_FORMAT)}`;

      return {
        name,
        checkinSequenceNo: item.sequenceNo,
        checkInEndDate: item.endDate,
        checkInStartDate: item.startDate
      };
    });

    //const currentExist = options.find(i => i.isCurrentFrequency);
    //const value = !isEmpty(currentExist) ? currentExist : options[0];
    const value = options[0];

    setFrequencyOptions(options);
    setSelectedFrequency(value);
  }, [checkinFrequencyDates]);

  return (
    !isEmpty(frequencyOptions) && (
      <Fragment>
        {label ? (
          <Typography variant="subtitle2" className="font-13 font-semibold">
            {label}
          </Typography>
        ) : null}
        <div className="frequency-field">
          <SelectField
          data-testId='data'
            key={get(selectedFrequency, "name")}
            options={frequencyOptions}
            onChange={e => handleFrequencyChange(e)}
            value={get(selectedFrequency, "name")}
          />
        </div>
      </Fragment>
    )
  );
};

export default FrequencyFilter;
